import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/GenZ_Logo.svg";
import "../App.css";

const LandingPage = () => {
  return (
    <div className="landing-page">
      <img src={logo} alt="GenZ Logo" className="logo" loading="lazy" />
      <p className="centered-text">
      Please sign in if you received the invite and signed up to 360.
      </p>
      <Link
        to="/login"
        style={{
          padding: "20px 40px",
          display: "flex",
          borderRadius: "10px",
          backgroundColor: "#ff2a2f",
          width: "200px",
          height: "50px",
          color: "white",
          opacity: "90%",
          fontSize: "24px",
          justifyContent: "center",
          alignItems: "center",
          textDecoration: "none",
          marginBottom: "20px",
          fontFamily: "'Acumin-RPro', sans-serif",
        }}
      >
        Let's Go!
      </Link>
      <p className="smallCentered-text">If you have received an invite to join 360, please sign up first.
      </p>
      <Link to="/signup" className="apply">
        Sign up <span className="highlight">here</span>
      </Link>
    </div>
  );
};

export default LandingPage;
